"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chunkString = void 0;
const chunkString = (string, length) => {
    // console.log('chunk', string, length, string.match(new RegExp('.{1,' + length + '}', 'g')));
    return string.match(new RegExp('.{1,' + length + '}', 'g'));
};
exports.chunkString = chunkString;
//# sourceMappingURL=index.js.map